const variants = [
  {
    props: { fit: 'tight' },
    style: {
      minWidth: 0,
      marginRight: '8px',
    },
  },
  {
    props: { fit: 'compact' },
    style: {
      minWidth: 0,
      marginRight: '16px',
    },
  },
];

export default variants;
